<template lang="pug">
  div(
    key="mediaCardBase"
    @click="!isMediaLibrary ? handleMedia() : null"
    :style="[styles.card.base(src, isActiveItem), ...viewSpecificStyles]"
    class="media-row"
    @mouseover="isMediaLibrary ? showOptions() : null"
    @mouseout="isMediaLibrary ? hideOptions() : null"
  )
    div(
      class="media-row-thumbnail"
    )
      img(
        :src="src"
      )
    div.media-row-metadata
      p {{title}}
      div
        span(
          :style="styles.contentTag(contentType || 'video')"
        ) {{contentType || 'video'}}
        span.mm-id-tag \#{{ media.mmId }}
    button.button__action(
      @click="handleMedia"
    ) Edit
</template>
<script>
import store from '../../store';
import { postResource } from '../../services/Utils.js';
import VueNotifications from 'vue-notifications';
import Services from '../../services/Services'
export default {
  name: 'mediaRow',
  props: {
    onClick: Function,
    isActionCard: Boolean,
    isTop: Boolean,
    media: Object,
    viewSpecificStyles: Object,
    cardSpecificStyles: Object,
    _id: String,
    src: String,
    isActiveItem: Boolean,
    isMediaLibrary: Boolean,
    contentType: String,
    content: String,
    refreshMedia: Function,
    title: String,
    selectedMlId: String,
    selectedPgId: String,
  },
  methods: {
    handleMedia() {
      console.log('clicking')
      if(this.isActionCard){
        this.onClick(true);
      } else {
        this.onClick(this.media);
        console.log('go to media');
        this.$router.push('/media/' + store.getters.getActiveMedia._id);
      }
    },
    showOptions() {
      this.visibleOptions = true;
    },
    hideOptions() {
      this.visibleOptions = false;
    },
    showSuccess() {
      // give cards a little time to move
      setTimeout(() => {
        this.showSuccessMsg({ message: 'Media moved to top!' });
      }, 400);
    },
    moveToTop() {
      // create top level position
      const update = {
        position: store.getters.getMedia[0].position + 1
      }

      const selectedMlId = this.selectedMlId;
      const selectedPgId = this.selectedPgId;

      postResource(`/v1/media/update?mediaId=${this.media._id}`, false, update, this.showSuccess())
        .then(res => {
          this.refreshMedia();
          return res;
        })
        .catch(err => {
          console.log(err);
          this.showErrorMsg({
            message: 'An error occurred. Please try again.'
          });
        });
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data() {
    return {
      visibleOptions: false,
      tagColors: {
        video: {
          bg: '#09a3ed',
          text: '#fff'
        },
        image: {
          bg: 'purple',
          text: '#fff'
        },
        audio: {
          bg: 'green',
          text: '#fff'
        },
        pdf: {
          bg: 'orange',
          text: '#444'
        }
      },
      styles: {
        card: {
          base: (src, active) => ({
            background: '#fff',
            flex: '0 0 auto',
            margin: 0,
            display: 'flex',
            flexFlow: 'row nowrap',
            justifyContent: 'flex-start',
            fontWeight: '400',
            fontSize: '1em',
            width: '100%',
            textAlign: 'left',
            padding: '10px',
            borderBottom: '1px solid #eee',
          })
        },
        title: {
          margin: '10px 0 0',
          fontWeight: '700',
          lineHeight: '1.25rem'
        },
        contentTag: type => ({
          background: this.tagColors[type].bg || '#888',
          display: 'inline',
          color: this.tagColors[type].text || '#fff',
          padding: '5px',
          borderRadius: '4px',
          fontSize: '0.7em',
          fontWeight: '700',
          textTransform: 'uppercase',
          margin: '0 auto auto 0',
        })
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.media-row-thumbnail {
  height: 60px;
  width: 60px;
  position: relative;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: auto 20px auto 0;

  img {
    position: absolute;
    width: 100px;
    left: -10px;
  }
}

.media-row-metadata {
  margin: auto auto auto 0;
  display: flex;
  flex-flow: column nowrap;

  div {
    display: flex;
    flex-flow: row nowrap;
    margin: 0 auto auto 0;

    span.mm-id-tag {
      color: #aaa;
      font-size: 0.9em;
      margin: auto auto auto 10px;
    }
  }

  p {
    margin: auto 0 6px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/general/MediaRow.vue